import React from 'react'
import moment from 'moment'
import { Tag } from '@blueprintjs/core'

import { TaskValueKey } from '../column-values/value-extractors'
import booleanExtractors, {
  BooleanKey,
} from '../column-values/boolean-extractors'
import numberExtractors, { NumberKey } from '../column-values/number-extractors'
import dateExtractors, { DateKey } from '../column-values/date-extractors'
import stringExtractors, { StringKey } from '../column-values/string-extractors'
import { TaskCellProps } from './task-cell'
import AuthorizedAgencyIcon from '../../authorized-agency-icon'
import { PRIORITY_THRESHOLD } from '../../../pages/configuration/constants'

const isBooleanKey = (valueKey: TaskValueKey): valueKey is BooleanKey =>
  valueKey in booleanExtractors
const isNumberKey = (valueKey: TaskValueKey): valueKey is NumberKey =>
  valueKey in numberExtractors
const isDateKey = (valueKey: TaskValueKey): valueKey is DateKey =>
  valueKey in dateExtractors
const isStringKey = (valueKey: TaskValueKey): valueKey is StringKey =>
  valueKey in stringExtractors

const makeGenericTaskCell =
  (valueKey: TaskValueKey) =>
  ({ task }: TaskCellProps) => {
    if (isStringKey(valueKey)) {
      const value = stringExtractors[valueKey](task)
      return (
        <>
          {value ?? null}
          {(valueKey === 'companyName' &&
            task._raw?.configuration?.is_authorized) ? (
            <AuthorizedAgencyIcon marginLeft={2} />
          ) : (
            ''
          )}
        </>
      )
    }
    if (isDateKey(valueKey)) {
      const value = dateExtractors[valueKey](task)
      return <>{value ? moment(value).format('lll') : '-'}</>
    }
    if (isNumberKey(valueKey)) {
      const value = numberExtractors[valueKey](task)
      return (
        <>
          {value ? (
            value > PRIORITY_THRESHOLD ? (
              <Tag intent="warning">{value}</Tag>
            ) : (
              value
            )
          ) : (
            ''
          )}
        </>
      )
    }
    if (isBooleanKey(valueKey)) {
      const value = booleanExtractors[valueKey](task)
      return <>{value ?? ''}</>
    }
    return <></>
  }

export default makeGenericTaskCell
